import React from 'react';
import { StoreLocatorForm } from './StoreLocatorForm';
import { StoreLocatorTile } from './StoreLocatorTile';
import { LoadingMoreSpinner } from 'src/scripts/templates/product-listing-page/components/SmallUIComponents';
import { openStoreLocatorSidebar } from './storeLocatorSidebarState';
import { observer } from 'mobx-react-lite';
import { bopisState } from '../Bopis/bopisState';
import { ShippingCountryState } from '../../../../utils/shipping';
import { IStoreAvailabilityData, StoreLocatorSidebarPdpData, StoreLocatorType } from './storeLocatorTypes';
import StoreLocatorTitle from './StoreLocatorTitle';
import { findInStoreState } from '../FindInStore/findInStoreState';
import { SiteSettings } from 'src/scripts/utils/environment';
import './style.scss';
import { IVariant } from '../../types/PDP';
import { isEmpty } from 'lodash-es';

let StoreLocatorPDP = ({
  title,
  userSelectedSize,
  storeLocatorType,
  sidebarPdpData,
  selectedVariant,
  isLoading = false,
}: {
  title: string;
  userSelectedSize: string | undefined;
  storeLocatorType: StoreLocatorType;
  sidebarPdpData: StoreLocatorSidebarPdpData;
  selectedVariant: IVariant | undefined;
  isLoading?: boolean;
}) => {
  const storesData = storeLocatorType === 'fis' ? findInStoreState.storesData?.slice(0, 3) : bopisState.storeSelection;
  const pricingDisclaimer = SiteSettings?.findInStorePricingDisclaimer;
  const showError = storeLocatorType === 'fis' ? findInStoreState.storesDataError : bopisState.pdpStoresDataError;
  const noResultsCopy =
    storeLocatorType === 'fis'
      ? `Sorry, there are no ALO stores found near you. Try a different ${
          ShippingCountryState.countryCode.toLowerCase() === 'us' ? 'zip' : 'postal'
        } code.`
      : 'No stores found near you. Try a different zip code or have it shipped.';

  if (showError) {
    // If there's an error, return the error UI
    return (
      <div className="store-locator-pdp">
        <StoreLocatorTitle title={title} storeLocatorType={storeLocatorType} />
        <StoreLocatorForm storeLocatorType={storeLocatorType} selectedVariant={selectedVariant} />
        <div className="store-locator-no-results">Something went wrong. Please try again later.</div>
      </div>
    );
  }

  if (isLoading) {
    return <LoadingMoreSpinner />;
  }

  return (
    <div className="store-locator-pdp">
      <StoreLocatorTitle title={title} storeLocatorType={storeLocatorType} />
      {ShippingCountryState.countryCode ? (
        !userSelectedSize ? (
          <p className={storeLocatorType === 'bopis' ? 'store-inventory-message' : ''}>
            Select a Size to Check Store Inventory
          </p>
        ) : (
          <>
            {(storeLocatorType === 'fis' ||
              (storeLocatorType === 'bopis' &&
                (isEmpty(bopisState.storeSelection) || !storesData || storesData?.length === 0))) && (
              <StoreLocatorForm storeLocatorType={storeLocatorType} selectedVariant={selectedVariant} />
            )}

            {storesData && storesData.length === 0 ? (
              <p className="store-locator-no-results">{noResultsCopy}</p>
            ) : storesData ? (
              <div className="store-locator-tile-pdp-container d-flex">
                {pricingDisclaimer && storeLocatorType === 'fis' ? (
                  <p className="store-locator-pricing-disclaimer black-text">{pricingDisclaimer}</p>
                ) : null}
                {storesData.map((storeAvailabilityData: IStoreAvailabilityData) => (
                  <StoreLocatorTile
                    store={storeAvailabilityData}
                    inputName="pdp"
                    showFullTile={false}
                    isAvailableOnline={Boolean(sidebarPdpData?.isAvailableOnline)}
                    key={storeAvailabilityData.location_id}
                    storeSelectionEnabled={storeLocatorType === 'bopis' ? true : false}
                  />
                ))}
                <div
                  className="details-link"
                  onClick={() => {
                    openStoreLocatorSidebar({
                      feature: storeLocatorType,
                      pdpProps: sidebarPdpData,
                      page: 'pdp',
                    });
                  }}
                >
                  Check Additional Stores
                </div>
              </div>
            ) : null}
          </>
        )
      ) : null}
    </div>
  );
};

StoreLocatorPDP = observer(StoreLocatorPDP);
export { StoreLocatorPDP };
